<template>
  <header class="header">
    <h2 class="header-title">{{title}}</h2>
    <button type="button" class="button-back" v-if="isBack()" @click="back"><span class="blind">뒤로가기 버튼</span></button>
  </header>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Header',
  data() {
    return {
      title: '',
      message: ''
    };
  },
  created() {
    this.title = this.$route.meta.title;
  },
  methods: {
    isBack() {
      if (this.$route.path === '/deliver/register' || this.$route.path === '/deliver/request') {
        return true;
      } else {
        return false;
      }
    },
    back(){
      if (this.$route.path === '/deliver/request') {
        this.message = '이전페이지로 이동하시겠습니까?'
      } else {
        this.message = '입력하신 정보가 초기화 됩니다. 이전페이지로 이동하시겠습니까?'
      }
      if(confirm(this.message)){
        this.$router.go(-1)
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/mixin.scss';
.header {
  height: 50px;
  position: relative;
  .header-title{
    font-size: 20px;
    text-align: center;
    line-height: 50px;
    font-weight: 500;
  }
  .button-back {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 50px;
    height:50px;
    background: url(../assets/images/icon-back-arrow-black.png) no-repeat center center;
    background-size: 27px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue